import {
  FlowDurationUnits,
  FlowHieDocumentFormat,
  type FlowHieGetDocumentsBlock,
  FlowHieGetDocumentsBlockConfigSchema,
} from 'flow-schema';

import { HieGetDocumentsFormFields } from './FormFields';
import { HieGetDocumentsBlockDocumentationMarkdown } from './documentation';
import type { BlockConfigProps } from '../../types';

export const hieGetDocumentsConfig: BlockConfigProps<FlowHieGetDocumentsBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'hieGetDocuments',
  defaultConfig: {
    sourceBlock: {
      sourceBlockName: '',
    },
    resources: [],
    includeRelatedRecords: false,
    documentFormat: FlowHieDocumentFormat.ConsolidatedData,
    dateFrom: '',
    dateTo: '',
    timeout: {
      value: 10,
      units: FlowDurationUnits.Minutes,
    },
  },
  configFields: {
    schema: FlowHieGetDocumentsBlockConfigSchema,
    FormFields: HieGetDocumentsFormFields,
  },
  documentationMarkdown: HieGetDocumentsBlockDocumentationMarkdown,
};
